const NAMESPACE = "tagErrorsDialog";

const KEYS = {
    defaultMsg: "defaultMsg"
};

const MESSAGES = {
    [KEYS.defaultMsg]: {
        value: "PowerClerk detected issues with some of the tags in your template.",
        comment: "Default error message for the tag errors dialog"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
